import { Profile } from "@types";
import { CORE_ACTION } from "../types/CoreAction";

const updateProfile = (profile: Profile) => {
  return {
    type: CORE_ACTION.UPDATE,
    payload: { user: profile },
  };
};

export default updateProfile;
